<template>
    <div>
        <div v-for="index in parseInt(cData['amount_of_belt_change'])" :key="index">
            <br>
            <p class="title">{{trans('belt_selection')}} #{{index}}</p>
            <v-select :diabled="!edit" :id="'select-'+k" v-model="cData['belt_selection_' + index]" :options="genereateOptions(structure['belt_selection'].options)" :reduce="o => o.value" label="key" @input="updateData()"/>

            <p v-if="cData['belt_selection_' + index] == 'belt_spz'" class="title">{{trans('belt_spz_selection')}} #{{index}}</p>
            <p v-else-if="cData['belt_selection_' + index] == 'belt_spa'" class="title">{{trans('belt_spa_selection')}} #{{index}}</p>
            <p v-else-if="cData['belt_selection_' + index] == 'belt_spb'" class="title">{{trans('belt_spb_selection')}} #{{index}}</p>
            <p v-else-if="cData['belt_selection_' + index] == 'belt_spc'" class="title">{{trans('belt_spc_selection')}} #{{index}}</p>

            <!-- spz -->
            <v-select :diabled="!edit" v-if="cData['belt_selection_' + index] == 'belt_spz'" :id="'select-'+k" v-model="cData['belt_selection_spz_' + index]" :options="genereateOptions(structure['belt_selection_spz'].options)" :reduce="o => o.value" label="key" @input="updateData()"/>

            <!-- spa -->
            <v-select :diabled="!edit" v-else-if="cData['belt_selection_' + index] == 'belt_spa'" :id="'select-'+k" v-model="cData['belt_selection_spa_' + index]" :options="genereateOptions(structure['belt_selection_spa'].options)" :reduce="o => o.value" label="key" @input="updateData()"/>

            <!-- spb -->
            <v-select :diabled="!edit" v-else-if="cData['belt_selection_' + index] == 'belt_spb'" :id="'select-'+k" v-model="cData['belt_selection_spb_' + index]" :options="genereateOptions(structure['belt_selection_spb'].options)" :reduce="o => o.value" label="key" @input="updateData()"/>

            <!-- spc -->
            <v-select :diabled="!edit" v-else-if="cData['belt_selection_' + index] == 'belt_spc'" :id="'select-'+k" v-model="cData['belt_selection_spc_' + index]" :options="genereateOptions(structure['belt_selection_spc'].options)" :reduce="o => o.value" label="key" @input="updateData()"/>

            <p class="title">{{trans('belt_lenght_in_mm')}} #{{index}}</p>
            <input :diabled="!edit" @change="updateData()" v-model="cData['belt_lenght_in_mm_' + index]" type="number" class="input-field">

            <p class="title">{{trans('belt_replaced')}}  #{{index}}</p>
            <v-select :diabled="!edit" :id="'select-'+k" v-model="cData['belt_replaced' + index]" :options="genereateOptions(['replace_belt', 'dont_do_anything'])" :reduce="o => o.value" label="key" @input="updateData()"/>

            <p class="title">{{trans('belt_selection_comment')}} #{{index}}</p>
            <input :diabled="!edit" @change="updateData()" v-model="cData['belt_selection_comment_' + index]" type="text" class="input-field">

            <p class="title">{{trans('belt_after_image')}} #{{index}}</p>
            <imageInput :diabled="!edit" :keyValue="'belt_after_image_' + index" :imagePath="cData['belt_after_image_' + index]" @change="imageChange" />

        </div>
    </div>
</template>

<script>
    export default {
        name: 'chillFilter',
        props: {
            cData: Object,
            edit: Boolean,
            k: String,
            structure: Object,
            updateData: Function,
            imageChange: Function
        },
        methods: {
            genereateOptions(options){
                let re = []
                for(let o of options){
                    re.push({key: this.trans(o), value: o})
                }
                return re
            }
        }
    }
</script>